import { getCustomSpotStep } from './get_custom_spot_step'

export const getSpotStepFromValues = (values) => (
  values.spotStep === 'custom'
    ? getCustomSpotStep(values.customSpotStep, values.customSpotStepType)
    : parseInt(values.spotStep, 10)
)

export const formatValuesToServerData = (values) => ({
  spot_step: getSpotStepFromValues(values),
})
